<template>
  <div class="container-score">
    <div class="score">
      <div class="enterpriseType">
        <div class="leftUnit">
          <p>{{ algorithmRatingName || '无' }}</p>
          <p>单位类型</p>
        </div>
        <div class="rightUnit">
          <div class="ranking">
            <p>{{ algorithmRatingRanking || 0 }}</p>
            <p class="slopingside"></p>
            <p>{{ algorithmRatingTotal || 0 }}</p>
            <p>当前排名</p>
          </div>
        </div>
      </div>
      <div class="comScore mt20">
        <div class="leftUnit">
          <p>综合评分</p>
          <p>{{ algorithmRatingScore || 0 }}</p>
        </div>
        <div class="rightUnit">{{ algorithmRatingGrade || 0 }} 级</div>
      </div>
      <div class="updateTime">
        <p class="center">下次更新时间</p>
        <p class="ml10 center">00 : 30 : 00</p>
        <p class="ml10"><el-button plain @click="ScoreUpdate" type="primary">立即更新</el-button></p>
      </div>
      <div class="maturity" v-if="$store.state.user.userInfo.natureId == 2">
        <span v-if="lateDate">
          <i class="el-icon-bell noticeAnimate" style="color:#fff;background:red;border-radius:50%;height:22px;width:22px;padding-top:1px;text-align: center;line-height: 20px;">
          </i>
          <router-link :to="{ path: '/fireFacilitiesManage' }">
            <span class="ml15" style="color: #8994a9" :title="'消防设施存在到期情况,请尽快处理!'">设施到期提醒</span>
          </router-link>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { algorithmRating, comprehensiveScoreUpdate } from '@/api/report.js';
export default {
  props: ['cpNum', ''],

  data() {
    return {
      algorithmRatingList: [], // 评分列表
      algorithmRatingName: '', // 企业类型
      algorithmRatingRanking: '', // 排名
      algorithmRatingScore: '', // 评分
      algorithmRatingGrade: '', // 等级
      algorithmRatingTotal: '', // 总排名
      lateDate: false,
    };
  },

  watch: {
    cpNum() {
      this.getalgorithmRatingList();
    },
    // $router() {
    //   Object.assign(this.algorithmRatingList, this.algorithmRatingName, this.algorithmRatingRanking, this.algorithmRatingScore, this.algorithmRatingGrade);
    //   this.getalgorithmRatingList();
    // },
  },

  mounted() {
    if (this.$store.state.user.userInfo.natureId == 2) {
      this.$get('/trmoni/fireFacilitiesManage/policeButton', { companyId: this.$store.state.user.company.cCompanyNum }).then((res) => {
        this.lateDate = res.data;
      });
    }
  },

  methods: {
    getalgorithmRatingList() {
      algorithmRating({ companyNum: this.cpNum }).then((res) => {
        this.algorithmRatingList = res.data;
        if (res.data) {
          if (res.data?.csafeLevel == 39) {
            this.algorithmRatingName = '一般单位';
          } else if (res.data?.csafeLevel == 40) {
            this.algorithmRatingName = '火灾高危单位';
          } else if (res.data?.csafeLevel == 41) {
            this.algorithmRatingName = '重点单位';
          } else if (res.data?.csafeLevel == 42) {
            this.algorithmRatingName = '九小场所';
          } else if (res.data?.csafeLevel == 0) {
            this.algorithmRatingName = '监管单位';
          }
          this.algorithmRatingRanking = res.data?.rankNum;
          this.algorithmRatingScore = res.data?.score;
          this.algorithmRatingGrade = res.data?.scoreNumStr;
          this.algorithmRatingTotal = res.data?.maxNum;
        }
      });
    },
    ScoreUpdate() {
      comprehensiveScoreUpdate({ companyNum: this.cpNum }).then((res) => {
        this.getalgorithmRatingList();
        // this.$message.success('更新成功');
        this.$message({
									message: "更新成功",
									type: 'success',
									duration: 700,
								});
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container-score {
  width: 100%;
  height: 92.5%;
  min-width: 170px;

  .score {
    width: 100%;
    height: 100%;
    border: 1px solid #2196f3;
    // 过期
    .maturity {
      width: 100%;
      height: 20px;
      margin-top: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .enterpriseType {
      width: 100%;
      height: 40%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-top: 10px;
      .leftUnit {
        width: 48%;
        height: 80%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-direction: column;
        padding: 5px;
        > p:nth-child(1) {
          width: 100px;
          color: #2e85e2;
          font-weight: bolder;
          font-size: 25px;
        }
        > p:nth-child(2) {
          text-align: start;
          width: 100px;
          font-size: 18px;
          font-weight: 600;
          letter-spacing: 0px;
          color: rgba(42, 43, 49, 1);
        }
      }
      .rightUnit {
        width: 48%;
        height: 100%;
        padding: 5px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .ranking {
          width: 95px;
          height: 100px;
          text-align: center;
          border-radius: 2px;
          background: rgba(241, 241, 241, 1);
          > p:nth-child(1) {
            /** 文本1 */
            font-size: 28px;
            font-weight: 400;
            text-align: center;
            color: rgba(42, 43, 49, 1);
            font-weight: 400;
          }
          > p:nth-child(3) {
            padding-left: 40px;
            font-size: 16px;
          }
          > p:nth-child(4) {
            width: 6.25rem;
            font-size: 18px;
            font-weight: 600;
            color: rgba(42, 43, 49, 1);
          }
        }
      }
    }
    .comScore {
      display: flex;
      width: 100%;
      height: 25%;
      .leftUnit {
        width: 48%;
        height: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-direction: column;
        > p:nth-child(1) {
          font-size: 18px;
          font-weight: 600;
          line-height: 15.91px;
          color: rgb(0, 0, 0);
        }
        > p:nth-child(2) {
          color: #a5d63f;
          font-size: 30px;
          font-weight: bolder;
        }
      }
      .rightUnit {
        width: 48%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
      }
    }
    .updateTime {
      width: 100%;
      height: 5%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-top: 25px;
      > p:nth-child(1) {
        width: 100px;
      }
      > p:nth-child(2) {
        width: 100px;
      }
      > p:nth-child(3) {
        padding-right: 5px;
      }
    }
  }
}
.noticeAnimate {
  animation: warningmove 1.5s infinite;
}
@keyframes warningmove {
  from {
    background: yellow;
    color: rgb(255, 0, 0);
  }
  to {
    background: rgb(232, 16, 16);
    color: rgb(255, 255, 255);
  }
}
.ml15 {
  margin-left: 15px;
}

.slopingside {
  height: 0px;
  border: 1px solid rgb(72, 69, 69);
  width: 60px;
  margin-left: 1.625rem;
  transform: rotate(125deg);
  -o-transform: rotate(125deg);
  -moz-transform: rotate(125deg);
  -webkit-transform: rotate(150deg);
}
::v-deep .el-button {
  width: 60px;
  height: 20px;
  font-size: 10px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-radius: 50px;
  border: 2px solid rgb(221, 223, 233);
}
</style>
